export default __webpack_public_path__ + "static/media/disgusted_elaine_off.52cb8ad0.png";